import Vue from 'vue'
import '../static/iconfont/iconfont.css';	//引入字体图标
import './scss/base.common.scss';	//引入全局css
import './scss/mobile.common.scss';	//引入全局css
import './helpers/registerHelper.js';	//引入框架注册helper
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(ElementUI);
Vue.use(Vant);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
